const SLIDE_SELECTOR =
  '.puppy-auction-sponsor-rotation__stage .puppy-auction-sponsor-rotation__slide,' +
  '.puppy-auction-sponsor-rotation__slides .puppy-auction-sponsor-rotation__slide'
const ACTIVE_CLASS = 'is-active'

const initRotator = (container) => {
  if (container.dataset.puppyAuctionSponsorRotatorInitialised === 'true') return
  container.dataset.puppyAuctionSponsorRotatorInitialised = 'true'

  const slides = container.querySelectorAll(SLIDE_SELECTOR)
  if (slides.length <= 1) return

  const interval = parseInt(container.dataset.rotationInterval, 10) || 5000
  let currentIndex = 0

  setInterval(() => {
    slides[currentIndex].classList.remove(ACTIVE_CLASS)
    slides[currentIndex].setAttribute('aria-hidden', 'true')

    currentIndex = (currentIndex + 1) % slides.length

    slides[currentIndex].classList.add(ACTIVE_CLASS)
    slides[currentIndex].removeAttribute('aria-hidden')
  }, interval)
}

const initAll = () => {
  document
    .querySelectorAll('[data-puppy-auction-sponsor-rotator]')
    .forEach(initRotator)
}

document.addEventListener('turbolinks:load', initAll)
document.addEventListener('DOMContentLoaded', initAll)
